import request from '../../utils/request'
//合作
export function saveBusCooperatio(data) {
  return request({
    url:'officialWebsite/saveBusCooperation',
    method: 'post',
    data: data
  })
}
// 查验
export function queryGuarantee(data) {
  return request({
    url:'officialWebsite/queryGuarantee',
    method: 'post',
    data: data
  })
}
//理赔
export function claimApply(data) {
  return request({
    url:'officialWebsite/claimApply',
    method: 'post',
    data: data
  })
}

// 获取短信验证码 useCheckCode
export function sendCheckCode(data) {
  return request({
    url: '/sms/biz/sendCheckCode',
    method: 'post',
    data: data,
  })
}


// 校验短信验证码
export function useCheckCode(data) {
  return request({
    url: '/sms/biz/useCheckCode',
    method: 'post',
    data: data,
  })
}

//获取理赔页面
export function generateClaimUrl(data) {
  return request({
    url:'auto/claim/generateClaimUrl',
    method: 'post',
    data: data
  })
}
// 查询缴费状态
export function checkPay(data) {
  return request({
    url:'/webPaidFunction/checkPay',
    method: 'post',
    data: data
  })
}
// 微信生成支付订单
export function webWeChatPrepay(data){
  return request({
    url: '/webWeChatPay/webWeChatPrepay',
    method: 'get',
    params: data,
  });
}